import React, {FC} from 'react'

import cn from 'classnames/bind'
import {observer} from 'mobx-react-lite'

import MobxSelect from 'components/elements/fields/MobxSelect'
import MobxTextInput from 'components/elements/fields/MobxTextInput'
import {discountTypeOptions, taxTypeOptions} from 'src/models/Invoice/Invoice.configs'
import {useInvoiceStore} from 'src/utils/contexts/RootStore.context'

import s from './FieldsInvoiceTax.module.scss'

const cx = cn.bind(s)

interface IFieldsInvoiceTaxProps {
	className?: string
}

const FieldsInvoiceTax: FC<IFieldsInvoiceTaxProps> = ({className}) => {
	const freeInvoiceStore = useInvoiceStore()
	return (
		<fieldset className={cx('wrapper', className)}>
			<MobxSelect
				wrapperClassName="mt-2"
				name="taxType"
				data-testid="tax-type"
				store={freeInvoiceStore}
				label="tax type"
				options={taxTypeOptions}
			/>

			<MobxTextInput
				wrapperClassName="mt-2"
				name="taxRate"
				data-testid="tax-rate"
				placeholder="0"
				shouldHandleOldValue
				isNumber
				isFormatText
				store={freeInvoiceStore}
				label="tax rate"
			/>
			<MobxSelect
				wrapperClassName="mt-2"
				name="discountType"
				store={freeInvoiceStore}
				label="discount type"
				options={discountTypeOptions}
			/>
			{freeInvoiceStore.discountType !== 'none' && (
				<MobxTextInput
					wrapperClassName="mt-2"
					name="discountRate"
					store={freeInvoiceStore}
					label="discount rate"
					shouldHandleOldValue
					isNumber
					isFormatText
				/>
			)}
		</fieldset>
	)
}

FieldsInvoiceTax.displayName = 'FieldsInvoiceTax'

export default observer(FieldsInvoiceTax)
